<div class="internal-message" *ngIf="pinnedMessage">{{ pinnedMessage.content }}</div>

<div class="messages" [class.empty]="!messages || !messages.length || !chatEnabled">
    @if (chatEnabled) {
        @for (message of messages; track message.content) {
            <div class="message">
                <div class="header">
                    <div class="author">{{ message.from }}</div>
                    <div class="time">{{ message.timestamp | date: 'HH:mm' }}</div>
                </div>
                <div>{{ message.content }}</div>
            </div>
        } @empty {
            <div i18n>No messages</div>
        }
    } @else {
        <div i18n>Chat is disabled</div>
    }
</div>
